import { useMemo, useEffect } from "react";
import { createCustomEvent } from "./utils.js";
const dispatchTrackErrorEvent = async (getErrorDetails) => {
  try {
    const dynamicDetails = await getErrorDetails();
    const fullDetails = {
      id: "Event",
      Events_Error: "1",
      ...dynamicDetails
    };
    const event = createCustomEvent(fullDetails);
    globalThis.dispatchEvent(event);
  } catch (error) {
    console.error("[Tealium] Error dispatching track error event:", error);
  }
};
const handleTrackErrorEvent = async (getErrorDetails) => {
  try {
    const dynamicDetails = await getErrorDetails();
    if (dynamicDetails !== void 0) {
      await dispatchTrackErrorEvent(() => Promise.resolve(dynamicDetails));
    }
  } catch (error) {
    console.error("[Tealium] Error handling track error event:", error);
  }
};
const useTrackErrorEvent = (getErrorDetails) => {
  useEffect(() => {
    handleTrackErrorEvent(getErrorDetails);
  }, [getErrorDetails]);
};
const useDispatchTrackErrorEvent = () => {
  return useMemo(() => {
    return async (getErrorDetails) => {
      await handleTrackErrorEvent(getErrorDetails);
    };
  }, []);
};
export {
  dispatchTrackErrorEvent,
  useDispatchTrackErrorEvent,
  useTrackErrorEvent
};
//# sourceMappingURL=use-track-error-event.js.map
